 <form [formGroup]="formName">
        <div class="relative input-number-wrapper">
            <i class="pi pi-dollar dollar-icon"></i>
            <p-inputNumber [formControlName]="field?.isOneToMultiple ? field?.attributeCodeOneToMultiple : field.attributeCode" [min]="field?.validation?.min" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" class="w-full" [placeholder]="placeholder"> </p-inputNumber>
        </div>
</form>

